import React, { useEffect } from "react";
import { Box, Grid, Stack, Chip, Button, IconButton, Typography, useTheme, AvatarGroup, Avatar, Switch } from "@mui/material";
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import { useQuery } from "@tanstack/react-query";

import { useLocalStorage } from "../../../hooks/useLocalStorage";
//Hooks
//import { getReturns } from "../../hooks/returns.jsx";
//Controls
import AxionControls from "../../../components/controls/AxionControls";
//Icons
import StarOutlineIcon from '@mui/icons-material/StarOutline';
//import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
//import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

//import { styled } from '@mui/material/styles';
import { tokens } from "../../../assets/theme";
import { useState } from "react";
import dayjs from "dayjs";
import { FormattedMessage, useIntl } from "react-intl";
import messages from "../messages";

// import { getAllActivities, getRecurringSchedules } from "./hooks/fetchers";


const CustomerInformation = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { formatMessage } = useIntl();
    const states = [1, 2, 3, 4, 9];
    const stateNames = ["Regitered", "In progress", "Pick up", "Paid", "Ready"];
    const statesCount = [];
    const [filteredData, setfilteredData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [showChildrenFor, setShowChildrenFor] = useState(0);
    //const [instanceGermany, setInstanceGermany] = useLocalStorage("InstanceGermany", false);
    const [instanceCountry, setInstanceCountry] = useLocalStorage("instanceCountry", "SV");

    function formatDateFromTick(date) {
        let datePart = date ? new Date(date * 1000).toLocaleDateString('sv-SE') : "";
        return datePart;
    }
    function formatDateTimeFromTick(date) {
        let datePart = date ? new Date(date * 1000).toLocaleDateString('sv-SE') : "";
        let timePart = date ? new Date(date * 1000).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : "";
        return datePart + " " + timePart;
    }

    function getStatusText(status) {
        let statusText = "";
        switch (status) {
            case 1:
                statusText = formatMessage(messages.general_status1);
                break;
            case 2:
                statusText = formatMessage(messages.general_status2);
                break;
            case 999:
                statusText = formatMessage(messages.general_status999);
                break;
            case 3:
                statusText = formatMessage(messages.general_status3);
                break;
            case 4:
                statusText = formatMessage(messages.general_status4);
                break;
            case 9:
                statusText = formatMessage(messages.general_status9);
                break;
            case 10:
                statusText = formatMessage(messages.general_status10);
                break;
            default:
                statusText = formatMessage(messages.general_statusDefault);
                break;
        }

        return statusText;
    }

    function getStatusColor(status) {
        let color = "#aaaaaa"; //gray

        switch (status) {
            case "OK":
                color = "#00ff00"; //green
                break;
            case "VARNING":
                color = "#ff0000"; //red
                break;
            case "SPÄRR":
                color = "#ffeb3b"; //yellow
                break;
            case "STRÖ":
                color = "#00ff00"; //green
                break;
            case "INAKTIV":
                color = "#ff9800"; //orange
                break;
            case "PRO":
                color = "#ffeb3b"; //yellow
                break;
            case "UNVERIFIED":
                color = "#ffaaaa"; //grey
                break;
            default:
                color = ""; //no color
                break;
        }
        return color;

    }

    function getColor(status) {
        var color = "#000000"; //black
        switch (status) {
            case "OK":
                color = "#000000"; //black
                break;
            case "VARNING":
                color = "#ffffff"; //black
                break;
            case "SPÄRR":
                color = "#000000"; //yellow
                break;
            case "STRÖ":
                color = "#000000"; //green
                break;
            case "INAKTIV":
                color = "#000000"; //orange
                break;
            case "PRO":
                color = "#000000"; //yellow
                break;
            case "UNVERIFIED":
                color = "#ffffff"; //yellow
                break;
            default:
                color = "#000000"; //no color
                break;
        }
        return color;
    }

    function getTextFieldStyles() { "sx: {backgroundColor: '#fff', padding: '5px'}" };

    const handleRowChange = (event) => {
        //############################
        console.log("Row change: ", event.target.value);
    }

    if (props.data === null) {
        return <Box color="white">Data is missing...</Box>;
    }

    const styles = theme => ({
        textField: {
            width: '90%',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingBottom: 0,
            marginTop: 0,
            fontWeight: 500
        },
        input: {
            color: 'white'
        }
    });

    //console.log("Customer Data: ", props.data);

    let showAll = (props.data?.statusid !== 2) || props.showHidden === true;

    let content = <>
        <Box color={colors.primary[100]}>

            <Grid container alignItems="center" width="100%" height="100%" direction="row" spacing="1px" padding="10px">
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_customerNumber} /></Typography></Grid>
                <Grid item xs={9}>
                    <Typography>{props.data?.id}</Typography>
                </Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_organizationalNumber} /></Typography></Grid>
                <Grid item xs={9}><AxionControls.AxionTextBox id="ynumber" label="" value={props.data?.ynumber} sx={{ width: '300px' }} onChange={(event) => handleRowChange(event)} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_customerName} /></Typography></Grid>
                <Grid item xs={9}><AxionControls.AxionTextBox id="ynumber" label="" value={props.data?.ynumber} sx={{ width: '300px' }} onChange={(event) => handleRowChange(event)} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_status} /></Typography></Grid>
                <Grid item xs={9} sx={{ height: '40px' }} display="flex" alignItems="center">
                    <Chip key={9} label={props.data?.status} size='small' sx={{ backgroundColor: getStatusColor(props.data?.status), color: getColor(props.data?.status) }} />
                </Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_contactPerson} /></Typography></Grid>
                <Grid item xs={9}><AxionControls.AxionTextBox id="contactperson" label="" value={props.data?.contactperson} sx={{ width: '300px' }} onChange={(event) => handleRowChange(event)} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_phoneNumber} /></Typography></Grid>
                <Grid item xs={9}><AxionControls.AxionTextBox id="mobile" label="" value={props.data?.mobile} sx={{ width: '300px' }} onChange={(event) => handleRowChange(event)} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_email} /></Typography></Grid>
                <Grid item xs={9}><TextField id="outlined-basic" label="" placeholder="" variant="standard" value={props.data?.email} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', color: '#000' } }} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_zipCode} /></Typography></Grid>
                <Grid item xs={9}><TextField id="outlined-basic" label="" placeholder="" variant="standard" value={props.data?.zipcode} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', color: '#000' } }} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_address} /></Typography></Grid>
                <Grid item xs={9}><TextField id="outlined-basic" label="" placeholder="" variant="standard" value={props.data?.address} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', color: '#000' } }} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_city} /></Typography></Grid>
                <Grid item xs={9}><TextField id="outlined-basic" label="" placeholder="" variant="standard" value={props.data?.city} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', color: '#000' } }} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                {instanceCountry !== "DE" && <>
                    <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_bankName} /></Typography></Grid>
                    <Grid item xs={9}><TextField id="outlined-basic" label="" placeholder="" variant="standard" value={props.data?.bankname} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', color: '#000' } }} /></Grid>
                    <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                    <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_iban} /></Typography></Grid>
                    <Grid item xs={9}><TextField id="outlined-basic" label="" placeholder="" variant="standard" value={props.data?.iban} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', color: '#000' } }} /></Grid>
                    <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                    <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_bic} /></Typography></Grid>
                    <Grid item xs={9}><TextField id="outlined-basic" label="" placeholder="" variant="standard" value={props.data?.bic} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', color: '#000' } }} /></Grid>
                    <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                    <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_giro} /></Typography></Grid>
                    <Grid item xs={9}><TextField id="outlined-basic" label="" placeholder="" variant="standard" value={props.data?.giro} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', color: '#000' } }} /></Grid>
                    <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                </>}
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_active} /></Typography></Grid>
                <Grid item xs={9}><TextField id="outlined-basic" label="" placeholder="" variant="standard" value={props.data?.active} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', color: '#000' } }} /><Switch checked={props.data?.active} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={3}><Typography><FormattedMessage {...messages.customerInformation_newsletter} /></Typography></Grid>
                <Grid item xs={9}><TextField id="outlined-basic" label="" placeholder="" variant="standard" value={props.data?.newsSubscribed} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', color: '#000' } }} /><Switch checked={props.data?.newsSubscribed} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
            </Grid>

        </Box>
    </>;

    return (
        <>
            {content}
        </>
    )
};

export default CustomerInformation;
